/** PURE_IMPORTS_START _operators_find PURE_IMPORTS_END */
import { FindValueOperator } from '../operators/find';
export function findIndex(predicate, thisArg) {
    return function (source) { return source.lift(new FindValueOperator(predicate, source, true, thisArg)); };
}
//# sourceMappingURL=findIndex.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/operators/findIndex.js
// module id = 1985
// module chunks = 0